module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Bold2.4b7f5140.woff2";